var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown ? _c("app-toolbar") : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-margin": "" } },
        [
          _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "6" } },
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("account"))),
                          ]),
                          _c(
                            "w-card-content",
                            [
                              _c(
                                "w-row",
                                [
                                  _vm.error
                                    ? _c(
                                        "w-col",
                                        {
                                          staticClass: "error",
                                          attrs: { xs: "12", xl: "12" },
                                        },
                                        [_vm._v(" " + _vm._s(_vm.error) + " ")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", xl: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct("workspace-url"),
                                        },
                                        model: {
                                          value: _vm.workspaceUrl,
                                          callback: function ($$v) {
                                            _vm.workspaceUrl = $$v
                                          },
                                          expression: "workspaceUrl",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-card-actions",
                            [
                              _c("w-spacer"),
                              _c(
                                "w-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateWorkspaceUrl()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("common.save")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "6" } },
                    [_c("app-dossier-list")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }